module.exports = __webpack_public_path__ + "img/adminsion2027-2.41941bc4.webp";